<template>
  <div
    v-if="workflowCategories.length"
    class="flex flex-col"
    data-cy="category-filter"
  >
    <workflow-category-filter-section
      :name="$t('COMMON.ALL')"
      :active="!selectedCategoryIds.length"
      @click="selectAll"
    />
    <workflow-category-filter-section
      v-for="category in workflowCategories"
      :key="category.id"
      :name="category.title"
      :active="isSelectedCategory(category.id)"
      @click="updateCategories(category.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { type PropType, ref } from "vue";

import { useWorkflowCategoriesInfo } from "@/hooks/workflow";

import WorkflowCategoryFilterSection from "@/components/presets/presetModal/WorkflowCategoryFilterSection.vue";

const emit = defineEmits<{
  (eventName: "update:modelValue", id: number[]): void;
}>();

defineProps({
  modelValue: {
    type: Array as PropType<number[]>,
    required: true,
  },
});

const { workflowCategories } = useWorkflowCategoriesInfo();

const selectedCategoryIds = ref<number[]>([]);

const updateCategories = (id: number) => {
  selectedCategoryIds.value = [id];
  emit("update:modelValue", selectedCategoryIds.value);
};

const isSelectedCategory = (id: number) => {
  return selectedCategoryIds.value.includes(id);
};

const selectAll = () => {
  selectedCategoryIds.value = [];
  emit("update:modelValue", []);
};
</script>
